/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pleasecompletetheserequiredfields4Inputs */

const en_pleasecompletetheserequiredfields4 = /** @type {(inputs: Pleasecompletetheserequiredfields4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please complete these required fields:`)
};

const de_pleasecompletetheserequiredfields4 = /** @type {(inputs: Pleasecompletetheserequiredfields4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte füll diese Pflichtfelder aus:`)
};

/**
* | output |
* | --- |
* | "Please complete these required fields:" |
*
* @param {Pleasecompletetheserequiredfields4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const pleasecompletetheserequiredfields4 = /** @type {((inputs?: Pleasecompletetheserequiredfields4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pleasecompletetheserequiredfields4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pleasecompletetheserequiredfields4(inputs)
	return de_pleasecompletetheserequiredfields4(inputs)
});
export { pleasecompletetheserequiredfields4 as "pleaseCompleteTheseRequiredFields" }